"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthActions = exports.LoginURL = exports.AccountURL = void 0;
var AccountURL;
(function (AccountURL) {
    AccountURL["DEV"] = "https://account-dev.rockcontent.com";
    AccountURL["HMG"] = "https://accounthmg.rockcontent.com";
    AccountURL["PRD"] = "https://account.rockcontent.com";
})(AccountURL = exports.AccountURL || (exports.AccountURL = {}));
var LoginURL;
(function (LoginURL) {
    LoginURL["DEV"] = "https://logindev.rockcontent.com";
    LoginURL["HMG"] = "https://loginhmg.rockcontent.com";
    LoginURL["PRD"] = "https://login.rockcontent.com";
})(LoginURL = exports.LoginURL || (exports.LoginURL = {}));
var AuthActions;
(function (AuthActions) {
    AuthActions["LOGIN"] = "LOGIN";
    AuthActions["LOGOUT"] = "LOGOUT";
    AuthActions["LOGIN_SUCCESS"] = "LOGIN_SUCCESS";
    AuthActions["LOGIN_FAILURE"] = "LOGIN_FAILURE";
    AuthActions["POST_TOKEN"] = "POST_TOKEN";
    AuthActions["GET_TOKEN"] = "GET_TOKEN";
    AuthActions["SET_TOKEN"] = "SET_TOKEN";
    AuthActions["LOADED"] = "LOADED";
    AuthActions["IS_LOADED"] = "IS_LOADED";
})(AuthActions = exports.AuthActions || (exports.AuthActions = {}));
//# sourceMappingURL=sso.js.map